export function initDevelopmentShortcuts() {
    if (process.env.NODE_ENV === 'development') {
        import('./index').then((module) => module.init());
    }
}
